



































import Vue from 'vue'
import Component from 'vue-class-component'
import Icon from './Icon.vue'
import { VClosePopover, VPopover } from 'v-tooltip'
import LoaderWrapper from '@/components/layout/LoaderWrapper.vue'

@Component({
  props: {
    items: {
      type: Array,
      required: true
    },
    direction: {
      type: String,
      default: 'bottom'
    },
    trigger: {
      type: String,
      default: 'click'
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  directives: {
    VClosePopover
  },
  components: {
    LoaderWrapper,
    Icon,
    VPopover
  }
})
export default class DropdownNav extends Vue {
  emitOpen (value: boolean) {
    value
      ? this.$emit('open')
      : this.$emit('close')
  }
}
